import Vue from 'vue'

export default {

  exportViaEmail () {
    return Vue.http.get(
      `${process.vars.BACKEND_HOST}/api/ui/maintenance/zipcodes/export`
    )
  }
}
